angular.module('qbePortal').controller('PaypalCallbackController', [
	'$scope',
	'$state',
	'$stateParams',
	'dynamicRouter',
	'paymentService',
	'storage',
	'Util',
	'MODULE_INFO',
	'paymentLoggerService',
	function(
		$scope,
		$state,
		$stateParams,
		dynamicRouter,
		paymentService,
		storage,
		Util,
		MODULE_INFO,
		paymentLoggerService
	) {
		var $ctrl = this;
		$scope.$root.$broadcast('loading-animation-end');

		var success = ($stateParams.success = !!$stateParams.PayerID);

		if (!success) {
			// Go back to payment page if unsuccessful
			storage.setItem('paypal-confirm-details', {
				isSuccess: false,
				mode: 'paypal'
			});
			return $state.go(MODULE_INFO.paymentPageRouteName);
		}

		if (MODULE_INFO.id == 'payments') {
			paymentService
				.unAuthSendPaypalPaymentToGW(
					$stateParams.PayerID,
					$stateParams.sessionId,
					$stateParams.paymentId
				)
				.then(function(_guidewirePaypalPaymentResponse) {
					var confirmationData = {
						policyNumber:
							_guidewirePaypalPaymentResponse.data.policyNumber,
						accountNumber:
							_guidewirePaypalPaymentResponse.data.accountNumber,
						receiptNumber:
							_guidewirePaypalPaymentResponse.data.receiptNumber,
						isAwaitingProcess:
							_guidewirePaypalPaymentResponse.data.status ===
							'AWAITING_PROCESS',
						isSuccess:
							_guidewirePaypalPaymentResponse.data.status ===
							'SUCCESS'
					};

					storage.setItem('paypal-confirm-details', confirmationData);

					paymentLoggerService.trackQuoteStatus(
						'sending Paypal payment to GW',
						'show done page or error page',
						null
					);

					$state.go(MODULE_INFO.donePageRouteName, confirmationData);
					console.log(
						'Great success! PayPal payment done! Go to confirmation page with data ',
						confirmationData
					);
				});
		} else {
			paymentService
				.sendPaypalPaymentToGW(
					$stateParams.PayerID,
					$stateParams.sessionId
				)
				.then(function(_guidewirePaypalPaymentResponse) {
					var confirmationData = {
						policyNumber:
							_guidewirePaypalPaymentResponse.data.policyNumber,
						accountNumber:
							_guidewirePaypalPaymentResponse.data.accountNumber,
						isAwaitingProcess:
							_guidewirePaypalPaymentResponse.data.status ===
							'AWAITING_PROCESS'
					};
					paymentLoggerService.trackQuoteStatus(
						'sending Paypal payment to GW - payment successful',
						'show done page or error page',
						null
					);
					$state.go(MODULE_INFO.donePageRouteName, confirmationData);
					console.log(
						'Great success! PayPal payment done! Go to confirmation page with data ',
						confirmationData
					);
				});
		}
	}
]);
